
const ALERTS_INTERVAL = 15000;
const SCREENSHOTS_INTERVAL = 60000;
const REFRESH_ALLOWED_CADENCE_MS = 5000;


export { ALERTS_INTERVAL, SCREENSHOTS_INTERVAL, REFRESH_ALLOWED_CADENCE_MS };
